import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    IconButton,
    InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;

const PasswordChanger = ({ isOpen, onClose, userId }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (password && !passwordRegex.test(password)) {
            setError('პაროლი უნდა შეიცავდეს დიდ, პატარა ასოს და რიცხვს (მინ. 6 სიმბოლო)');
        } else {
            setError('');
        }
    }, [password]);

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    const handleSubmit = () => {
        if (error) return;
        setConfirmOpen(true);
    };

    const handleConfirm = async () => {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/CahngePasswrodByAdmin`, {
            id: userId,
            passwrod: password
        });
        setConfirmOpen(false);
        setPassword('');
        onClose();
    };

    return (
        <>
            <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogContent>
                    <TextField
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        label="ახალი პაროლი"
                        value={password}
                        onChange={handlePasswordChange}
                        error={!!error}
                        helperText={error}
                        margin="normal"
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(prev => !prev)} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>გაუქმება</Button>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!!error || password === ''}
                    >
                        დადასტურება
                    </Button>
                </DialogActions>
            </Dialog>

            <ConfirmationModal
                isOpen={confirmOpen}
                onRequestClose={() => setConfirmOpen(false)}
                onConfirm={handleConfirm}
                modalText="დარწმუნებული ხართ რომ გსურთ პაროლის შეცვლა?"
            />
        </>
    );
};

export default PasswordChanger;
